export const POSTHOG_KEYS = {
  RISK_MITIGATION_V2: 'pmd-risk-verification-v2',
  SUPPLIER_PORTAL_REDIRECT: 'pmd-sp-redirect',
  SELECT_ALL: 'pmd-select-all',
  RISK_VERIFICATION_ASSETS_DOWNLOAD_OPTION:
    'pmd-risk-verification-assets-download-option',
  MULTI_LINKED_PLOT_REPORT_DOWNLOAD_OPTION:
    'pmd-multi-linked-plot-report-download-option',
  SURVEY_RESPONSES_DOWNLOAD_OPTION:
    'pmd-survey-responses-report-download-option',
  GEOJSON_DOWNLOAD_OPTION: 'pmd-geojson-download-option',
  SUPPLIER_NAME_COLUMN: 'pmd-supplier-name-column',
  RISK_PREVIEW_REPORT: 'pmd-risk-preview-report',
  RISK_CONFIG: 'pmd-risk-config',
  SUPPLIER_PORTAL_SSO: 'supplier-portal-sso',
  SUPPLIER_PORTAL_AURA: 'supplier-portal-aura',
  SHOW_VERSIONS: 'pmd-show-versions',
  PLOT_REVIEW: 'pmd-plot-review',
  PLOT_LINKING: 'pmd-plot-linking',
  EVIDENCE_LINK: 'pmd-evidence-link',
  EVIDENCE_COLLECTION: 'pmd-evidence-collection'
};
